import React, { useEffect, useRef, useState } from "react";
import { NavLink as RouterLink } from "react-router-dom";
import FogEventsVideo from "../../videos/FOG/FOG_Events.mp4"; // ✅ replace with your FOG video if needed

function FogEventsCalendar() {
  /* ✅ VIDEO controls (same pattern as HinduRajneetiAcademy) */
  const [isMuted, setIsMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);
  const topVideoRef = useRef(null);
  const [showUpcoming, setShowUpcoming] = useState(false);
  const [openSection, setOpenSection] = useState(null);
  useEffect(() => {
    const v = topVideoRef.current;
    if (!v) return;

    v.muted = true;

    const playPromise = v.play();
    if (playPromise && typeof playPromise.then === "function") {
      playPromise
        .then(() => setIsPlaying(true))
        .catch(() => setIsPlaying(false));
    } else {
      setIsPlaying(!v.paused);
    }
  }, []);
  

  useEffect(() => {
    const v = topVideoRef.current;
    if (v) v.muted = isMuted;
  }, [isMuted]);

  const togglePlayPause = async () => {
    const v = topVideoRef.current;
    if (!v) return;

    if (v.paused) {
      try {
        await v.play();
        setIsPlaying(true);
      } catch {
        setIsPlaying(false);
      }
    } else {
      v.pause();
      setIsPlaying(false);
    }
  };

  const toggleMute = () => setIsMuted((m) => !m);
  

  return (
    <>
      <style>{`
        .mt-4 { margin-top: 1.5rem !important; }
        .mt-3 { margin-top: 1rem !important; }
        
        .fog-action-buttons {
          display: flex;
          gap: 1.25rem;
          justify-content: center;
          flex-wrap: wrap;
          margin-top: 2.5rem;
        }

        .fog-btn {
          position: relative;
          padding: 14px 34px;
          font-size: 16px;
          font-weight: 700;
          letter-spacing: 0.8px;
          text-transform: uppercase;
          border-radius: 50px;
          border: 2px solid transparent;
          background: linear-gradient(135deg, #ff9933, #ff6600);
          color: #ffffff;
          cursor: pointer;
          transition: all 0.35s ease;
          text-decoration: none;
          box-shadow: 0 10px 25px rgba(255, 153, 51, 0.35);
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }

        /* Secondary button */
        .fog-btn.secondary {
          background: transparent;
          border: 2px solid #ffffff;
          box-shadow: none;
        }

        .fog-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 15px 35px rgba(255, 153, 51, 0.5);
        }

        .fog-btn.secondary:hover {
          background: #ffffff;
          color: #000000;
          box-shadow: 0 12px 30px rgba(255, 255, 255, 0.35);
        }

        .fog-btn:active { transform: translateY(-1px); }

        /* ✅ Video section (copied behavior from HinduRajneetiAcademy) */
        html, body { overflow-x: hidden; }
        .fog-fullVideo{
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  height: auto;
  background: #000;
  position: relative;
  overflow: visible;
  border-radius: 6px;
}
        .fog-fullVideo video{ width: 100%;
  height: auto;
  object-fit: contain;
}
        .fog-videoControls{ position:absolute; top:auto; right:auto; bottom:16px; left:16px; display:flex; gap:10px; z-index:3; }
        .fog-ctrlBtn{
          border:1px solid rgba(255,255,255,.22); background:rgba(0,0,0,.45); color:#fff;
          border-radius:999px; padding:10px 14px; font-size:13px; letter-spacing:.02em;
          backdrop-filter:blur(10px); cursor:pointer; white-space:nowrap;
        }
        .fog-ctrlBtn:hover{ background:rgba(0,0,0,.6); }
        

        /* ✅ Fix nested link issue WITHOUT changing your button look */
        .fog-btn-link {
          color: inherit;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
        }
        .fog-upcoming-wrapper {
          margin-top: 3rem;
          display: flex;
          gap: 2rem;
          justify-content: center;
          flex-wrap: wrap;
          animation: fadeIn 0.4s ease;
        }

        .fog-upcoming-img {
          max-width: 420px;
          width: 100%;
          border-radius: 16px;
          box-shadow: 0 18px 40px rgba(0,0,0,0.35);
        }
/* Remove line/divider under heading */
.hra-topTitle::before,
.hra-topTitle::after,
.head-title::before,
.head-title::after {
  display: none !important;
  content: none !important;
  border: none !important;
}
.hra-topTitle{
  margin-bottom: -32px !important;
}
.section-divider{
  width:100%;
  max-width:900px;
  margin:32px auto 38px;

  display:flex;
  align-items:center;
  justify-content:center;
  gap:18px;
}

.section-divider::before,
.section-divider::after{
  content:"";
  flex:1;
  height:3px;

  background: linear-gradient(
    to right,
    transparent,
    #1a2a5a,
    #d4af37,
    transparent
  );

  border-radius:10px;

  box-shadow:
    0 2px 6px rgba(0,0,0,0.18);
}

.section-divider span{
  font-size:26px;
  color:#1a2a5a;
  text-shadow:0 2px 6px rgba(0,0,0,0.15);

  animation: dividerGlow 2.5s ease-in-out infinite;
}
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
.org-selector{
margin-top:60px;
margin-bottom:80px;
display:flex;
flex-direction:column;
align-items:center;
gap:18px;
}

.org-row{
display:flex;
align-items:center;
justify-content:center;  /* ✅ centers arrow + button */
gap:14px;
cursor:pointer;
}

.org-arrow{
font-size:28px;
color:#000;
}

.org-card{
background:linear-gradient(135deg,#ff9933,#ff6600);
border-radius:50px;
padding:16px 32px;
min-width:520px;
max-width:820px;
box-shadow:0 10px 25px rgba(255,153,51,.35);
margin:0 auto;
}

.org-card h4{
color:#fff;
font-size:16px;
font-weight:700;
margin:0;
}

.sub-options{
margin-top:10px;
display:flex;
flex-direction:column;
align-items:center;   /* ✅ centers items */
gap:14px;
}

.sub-row{
display:flex;
align-items:center;
justify-content:center;
gap:12px;
}

.sub-arrow{
font-size:18px;
color:#000;
}

.sub-card{
background:linear-gradient(135deg,#ffb366,#ff9933);
border-radius:40px;
padding:10px 24px;
min-width:200px;
box-shadow:0 8px 20px rgba(255,153,51,.35);
}

.sub-card h5{
margin:0;
color:#fff;
font-weight:700;
font-size:14px;
}
.fog-btn-icon{
  display:none;
}

.fog-btn-text{
  display:inline;
}
@media (max-width: 768px){ 
  /* Remove space above header */
  .block.color-scheme-4{
    padding-top: 0 !important;
    margin-top: 0 !important;
  }

  .container:first-child{
    padding-top: 0 !important;
  }

  .hra-topTitle{
    margin-top: 18px !important;
    margin-bottom: -48px !important;
  }

  .section-divider{
    margin: 12px auto 18px;
    gap: 8px;
  }

  .section-divider span{
    font-size: 16px;
  }

  /* Header */
  .head-title span,
  .hra-topTitle span{
    display:block;
    font-size: 1.8rem !important;
    line-height: 1.2;
    text-align:center;
    padding:0 12px;
  }

  .hra-topIntro{
    font-size: 0.9rem !important;
    line-height: 1.5;
    padding: 0 16px;
    margin-top: 10px;
  }

  /* Video */
  .fog-fullVideo{
    width:100%;
    border-radius:0;
    height:auto;
    aspect-ratio:unset;
  }

  .fog-videoControls{
    bottom:6px;
    left:6px;
    gap:4px;
  }

  .fog-btn-text{
  display:none;
}

.fog-btn-icon{
  display:inline;
  font-size:20px;
  line-height:1;
}

.fog-ctrlBtn{
  background:transparent !important;
  border:none !important;
  box-shadow:none !important;
  backdrop-filter:none !important;
  padding:0 !important;
  width:auto !important;
  height:auto !important;
  min-width:auto !important;
  border-radius:0 !important;
  color:#fff;
  cursor:pointer;
}

.fog-ctrlBtn:hover,
.fog-ctrlBtn:focus,
.fog-ctrlBtn:active{
  background:transparent !important;
  box-shadow:none !important;
}

  /* Event button section */
  .org-selector{
    margin-top: 18px;
    margin-bottom: 30px;
    padding: 0 12px;
  }
  .org-row{
    gap: 8px;
  }

  .org-arrow{
    font-size: 14px;
  }

  .org-card{
    width: auto;
    min-width: 260px;
    max-width: 320px;
    padding: 10px 16px;
    border-radius: 14px;
  }

  .org-card h4{
    font-size: 11px;
    line-height: 1.3;
    text-align: center;
  }

  .org-arrow{
    font-size:18px;
  }

  /* Content container */
  .col-md-10.col-lg-9{
    padding-left:18px !important;
    padding-right:18px !important;
  }

  /* Section titles */
  .mt-4{
    margin-top:1.25rem !important;
  }

  .mt-4 h3{
    font-size:1.15rem !important;
    line-height:1.3;
    margin-bottom:10px;
    text-align:center;
  }

  /* Paragraphs */
  .mt-4 p{
    font-size:0.92rem !important;
    line-height:1.7;
    text-align:left;
  }

  /* CTA buttons */
  .fog-action-buttons{
    gap:10px;
    margin-top:1.5rem;
  }

  .fog-btn{
    width:100%;
    max-width:280px;
    padding:12px 18px;
    font-size:13px;
  }

  /* Prevent horizontal scroll */
  .container,
  .row,
  .section-title-body{
    overflow-x:hidden;
  }
}        
@media (max-width: 480px) {

  .head-title span,
  .hra-topTitle span{
    font-size: 1.45rem !important;
  }

  .hra-topIntro{
    font-size: 0.82rem !important;
  }

  .mt-4 h3{
    font-size: 1rem !important;
  }

  .mt-4 p{
    font-size: 0.85rem !important;
    line-height: 1.65;
  }

  .org-card h4{
    font-size:12px;
  }

  .fog-btn-text{
  display:none;
}

.fog-btn-icon{
  display:inline;
  font-size:20px;
  line-height:1;
}

.fog-ctrlBtn{
  background:transparent !important;
  border:none !important;
  box-shadow:none !important;
  backdrop-filter:none !important;
  padding:0 !important;
  width:auto !important;
  height:auto !important;
  min-width:auto !important;
  border-radius:0 !important;
  color:#fff;
  cursor:pointer;
}

.fog-ctrlBtn:hover,
.fog-ctrlBtn:focus,
.fog-ctrlBtn:active{
  background:transparent !important;
  box-shadow:none !important;
}
}




      `}</style>

      <section>
        <div className="block color-scheme-4">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-9">
                <div className="section-sub-title center">
                  <article className="section-title-body white">
                    <h1 className="head-title hra-topTitle">
                      <span>FOG Annual Festivals & Programs</span>
                      <div className="section-divider">
  <span>✦ ✦ ✦</span>
</div> 
                    </h1>

                    <p className="hra-topIntro">
                      (Includes ALL FOG festival content, India Day Parade, Grand
                      Marshals, competitions, health fair, and more.)
                    </p>
                  </article>
                </div>
              </div>
            </div>
          </div>

          {/* ✅ Full-width video (like HinduRajneetiAcademy) */}
          <div className="fog-fullVideo">
            <video
              ref={topVideoRef}
              src={FogEventsVideo}   // ✅ replace with your FOG video file if needed
              playsInline
              muted={isMuted}
              autoPlay
              loop
              preload="metadata"
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
            />
            <div className="fog-videoControls">
              <button
  type="button"
  className="fog-ctrlBtn"
  onClick={togglePlayPause}
>
  <span className="fog-btn-text">
    {isPlaying ? "Pause ⏸️" : "Play ▶️"}
  </span>
  <span className="fog-btn-icon">
    {isPlaying ? "⏸️" : "▶️"}
  </span>
</button>

<button
  type="button"
  className="fog-ctrlBtn"
  onClick={toggleMute}
>
  <span className="fog-btn-text">
    {isMuted ? "Unmute 🔊" : "Mute 🔇"}
  </span>
  <span className="fog-btn-icon">
    {isMuted ? "🔇" : "🔊"}
  </span>
</button>
            </div>
          </div>
          <div>
        </div> 
    <div className="org-selector">

  <RouterLink
    to="/events-and-calender#fog"
    style={{ textDecoration: "none" }}
  >
    <div className="org-row">
      <span className="org-arrow">➤</span>

      <div className="org-card">
        <h4>
          Festival of Globe – 501 (c)(3) -Non Profit organization Events
        </h4>
      </div>
    </div>
  </RouterLink>

</div>


          {/* ✅ Updated content */}
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-9">
                <div className="section-sub-title center">
                  <article className="section-title-body white">
                    <div className="mt-4">
                      <h3 className="white">FOG CORE EVENTS</h3>
                      <p className="white">
                        Festival of Globe (FOG) is a celebration of life rooted in the Hindu way of living.
                        At its heart are FOG Core Events—grand-scale cultural, civic, and community experiences
                        designed to unite generations, showcase heritage, and inspire leadership. Each event
                        embodies pride, participation, and purpose, drawing communities from across the United States.
                      </p>
                    </div>

                    <div className="mt-4">
                      <h3 className="white">FOG Republic Day</h3>
                      <p className="white">
                        FOG Republic Day is a tribute to democracy, constitutional values, and civic responsibility.
                        This national celebration engages over 25,000 attendees annually, offering a unique platform
                        for citizens to reflect on freedom, governance, and the power of collective civic engagement.
                        Through speeches, cultural performances, and educational activities, Republic Day reinforces
                        pride in both Indian heritage and American democratic ideals.
                      </p>
                    </div>

                    <div className="mt-4">
                      <h3 className="white">FOG Holi</h3>
                      <p className="white">
                        Holi, the festival of colors, is celebrated by FOG as a symbol of joy, harmony, and togetherness.
                        Attracting more than 25,000 participants, this vibrant event brings families, youth, and communities
                        together to immerse in music, dance, and color play, fostering unity and spreading happiness across generations.
                      </p>
                    </div>

                    <div className="mt-4">
                      <h3 className="white">FOG Independence Day</h3>
                      <p className="white">
                        FOG Independence Day honors freedom, gratitude, and shared values. With a 25,000-strong floating crowd,
                        this event celebrates the spirit of liberty and multicultural pride, showcasing patriotic performances,
                        flag ceremonies, and inspiring narratives that connect participants with the legacy of India’s independence
                        while strengthening civic engagement in America.
                      </p>
                    </div>

                    <div className="mt-4">
                      <h3 className="white">FOG India Day Parade</h3>
                      <p className="white">
                        The FOG India Day Parade is the crown jewel of the Festival of Globe, recognized as the largest India Day Parade
                        in the United States. Every year, this iconic public spectacle attracts over 100,000 attendees, featuring elaborate
                        floats representing India’s diverse states, walking groups, cultural performances, and music. The parade has become a
                        national landmark, highlighting Hindu American pride, heritage, and community visibility on a grand scale, drawing
                        audiences from across the country.
                      </p>
                    </div>

                    <div className="mt-4">
                      <h3 className="white">FOG &amp; A4H Freedom Gala</h3>
                      <p className="white">
                        The FOG and Americans4Hindus Freedom Gala honors leadership, service, and national impact. This prestigious evening
                        brings together dignitaries, community leaders, and visionaries to celebrate individuals and organizations making
                        transformative contributions in civic engagement, policy, and culture. Through awards, keynote addresses, and networking,
                        the Gala reinforces the connection between culture, leadership, and nation-building.
                      </p>
                    </div>

                    <div className="mt-4">
                      <h3 className="white">FOG Idol</h3>
                      <p className="white">
                        FOG Idol is a national platform celebrating talent, creativity, and the voice of the next generation. With 25,000
                        attendees, this event showcases young performers across music, dance, and dramatic arts, empowering youth to express
                        cultural identity while cultivating confidence, discipline, and leadership skills that extend beyond the stage.
                      </p>
                    </div>

                    <div className="mt-4">
                      <h3 className="white">FOG Navaratri</h3>
                      <p className="white">
                        FOG Navaratri honors devotion, Shakti, and the continuity of cultural traditions. Celebrated with a 25,000-strong community,
                        it features traditional Garba and Dandiya dances, spiritual discourses, and devotional performances, bridging generations
                        while preserving deep-rooted cultural heritage.
                      </p>
                    </div>

                    <div className="mt-4">
                      <h3 className="white">FOG Diwali</h3>
                      <p className="white">
                        FOG Diwali illuminates hope, prosperity, and unity through the festival of lights. Over 25,000 attendees gather to witness
                        vibrant light displays, cultural programs, and family-oriented celebrations that emphasize the triumph of good over evil,
                        while fostering community bonds and shared joy.
                      </p>
                    </div>

                    <div className="mt-4">
                      <h3 className="white">FOG Telugu Sankranti</h3>
                      <p className="white">
                        FOG Telugu Sankranti honors regional heritage, family traditions, and generational roots with a 25,000-strong floating crowd.
                        This event showcases South Indian customs, rituals, music, and cuisine, preserving regional identity while integrating it into
                        the broader FOG platform of national cultural celebration.
                      </p>
                    </div>

                    <div className="mt-4">
                      <h3 className="white">FOG Leadership &amp; Civic Initiatives</h3>
                      <p className="white">
                        Beyond festivals, FOG provides year-round platforms for leadership development, youth engagement, civic awareness, and
                        interfaith and multicultural alliances. These initiatives empower participants to serve, represent, and inspire communities,
                        bridging cultural pride with civic responsibility.
                      </p>
                    </div>

                    <div className="mt-4" style={{ marginBottom: "5rem" }}>
                      <h3 className="white">FOG Year-Round Vision</h3>
                      <p className="white">
                        FOG is expanding rapidly, with chapters, events, and initiatives across more cities and states, aiming to reach communities
                        across the United States by 2026. Each event is designed not only to celebrate heritage but also to create shared experiences,
                        foster intergenerational bonds, and strengthen community empowerment through culture, values, and civic engagement.
                      </p>
                    </div>
                    


                    <div className="mt-4">
                      <p className="white">
                        <strong>
                          Festival of Globe: Unity. Pride. Progress. Celebrate your life with the Hindu way of living.
                        </strong>
                      </p>
                    </div>

                    {/* ✅ Keep Donate + Become Volunteer buttons */}
                    

                  </article>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}

export default FogEventsCalendar;
